import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { dispensingModuleManager, moduleManager } from 'redux/action/modules';
import moment from 'moment';
import Popup from 'popup/Popup';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import EditableForm from './EditableForm';
import { DispensingEditablePopupContainer, DispensingEditable, DispensingModuleAreaSelectMap, MapIconContainer } from './DispensingEditablePopup.css.js';
import map from 'static/images/map/map_png.png';

const DispensingEditablePopup = ({ dispensing, dataReloadFunc, areas, modules, children }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(store => store.loginManager.status);
  const [ popupOpen, setPopupOpen ] = useState(null);
  const [ dispensingData, setDispensingData ] = useState(null);

  const dispensingInit = () => {
    setDispensingData(() => {
      return {
        'dispensingIdx': dispensing.dispensingIdx,
        'partner': dispensing.partner,
        'userNm': dispensing.userNm,
        'userTel': dispensing.userTel,
        'instNm': dispensing.instNm,
        'moduleIdx': dispensing.moduleIdx + "",
        'areaNm': dispensing.areaNm,
        'xAxis': dispensing.xAxis,
        'yAxis': dispensing.yAxis,
        'rgstId': dispensing.rgstId,
        'dispensingDt': dispensing.dispensingDt,
        'receivingDt': dispensing.receivingDt === "" ? null : dispensing.receivingDt,
        'modelNo': dispensing.modelNo,
        'moduleScnNm': dispensing.moduleScnNm,
        'moduleTypeNm': dispensing.moduleTypeNm
      }
    })
  }
  
  useEffect(() => {
    dispensingInit();
  }, [dispensing])

  const confirmModule = async () => {
    const [url, msg] = dispensing.length === 0 ? ['/api/dispensing/insertData', '불출']: 
                                                 ['/api/dispensing/updateData', '수정'];

    customAxiosPostFunction(history, url, {...dispensingData, 
                     dispensingDt: dispensing.length === 0 ? moment().format('YYYY-MM-DDTHH:mm:ssZ') : 
                                                             moment(dispensingData.dispensingDt).format('YYYY-MM-DDTHH:mm:ssZ'), 
                     rgstId: user.currentUser})
      .then(response => {
        if (response !== null && response !== 0) {
          dispatch(dispensingModuleManager(Number(user.authIdx)));
          dispatch(moduleManager(Number(user.authIdx)));
          alert(`${msg}완료`);
          window.location.reload(false);
        }
        else {
          alert(`${msg}실패`);
        }
      })
      .catch(function (error) {
        alert(`${msg}실패했습니다. 입력값을 확인`);
        console.log(error);
      });
  }

  // 맵에서 새로운 위치를 클릭 시
  const selectNewArea = useCallback((e) => {
    const offsetX = e.nativeEvent.offsetX;
    const offsetY = e.nativeEvent.offsetY;
    
    setDispensingData((dispensingData) => {
      return {
        ...dispensingData,
        xAxis: offsetX * (900 / 535),
        yAxis: offsetY * (900 / 535)
      }
    });
  }, [])

  if (!dispensingData) {
    return null;
  }

  return(
    <Popup
      trigger={
        children
      }
      modal
      open={popupOpen}
      onOpen={() => { setPopupOpen(true); }}
      onClose={() => { dispensingInit(); }}
    >
      <DispensingEditablePopupContainer>
        <DispensingEditable>
          <EditableForm dispensingData={dispensingData}
                        setDispensingData={setDispensingData}
                        confirmModule={confirmModule}
                        title={dispensing.length === 0 ? '불출' : '수정'}
                        areas={areas}
                        modules={modules} />
        </DispensingEditable>
        <DispensingModuleAreaSelectMap>
          {
            dispensingData.xAxis && dispensingData.yAxis && 
            <MapIconContainer xAxis={dispensingData.xAxis / (900 / 535)} yAxis={dispensingData.yAxis / (900 / 535)}>
              <img src='' alt="icon" />
            </MapIconContainer>
          }
          <img src={map} alt="map" onClick={selectNewArea} />
        </DispensingModuleAreaSelectMap>
      </DispensingEditablePopupContainer>
    </Popup>
  );
}

export default DispensingEditablePopup;